/*
 * dm-sticky-atc.js
 * Site-wide sticky add-to-cart bar: the button opens a color/size picker (a modal) and then adds the chosen
 * variant through the shared DMCart, which opens the cart drawer. Variant data is the real variants array.
 */
(function () {
  'use strict';
  var DM = window.DM;
  if (!DM) return;
  var str = DM.strings || {};

  // Landing pages on phones: dm-page.liquid hides the bar (CSS) until the in-page buy button has scrolled out of view.
  // With no button or no IntersectionObserver the bar is simply shown, as on every other page.
  function holdForLandingButton() {
    var bar = document.querySelector('[data-dm-sticky-atc]');
    if (!bar) return;
    var cta = document.querySelector('.lux-lp__cta .dm-btn');
    if (!cta || !('IntersectionObserver' in window)) {
      bar.classList.add('is-shown');
      return;
    }
    try {
      new window.IntersectionObserver(
        function (entries) {
          var e = entries[entries.length - 1];
          bar.classList.toggle('is-shown', !(e.isIntersecting && e.intersectionRatio >= 0.5));
        },
        { threshold: [0, 0.5, 1] }
      ).observe(cta);
    } catch (err) {
      bar.classList.add('is-shown');
    }
  }

  function init() {
    holdForLandingButton();
    var modal = document.getElementById('dm-sticky-picker');
    var raw = document.getElementById('dm-sticky-json');
    if (!modal || !raw) return;
    var data;
    try {
      data = JSON.parse(raw.textContent);
    } catch (e) {
      return;
    }
    var form = modal.querySelector('[data-dm-sp-form]');
    var inputs = DM.$$('.dm-opt__input', modal);
    var priceEl = modal.querySelector('[data-dm-sp-price]');
    var compareEl = modal.querySelector('[data-dm-sp-compare]');
    var labelEl = modal.querySelector('[data-dm-sp-label]');
    var addBtn = modal.querySelector('[data-dm-sp-add]');
    var errEl = modal.querySelector('[data-dm-sp-error]');
    var restLabel = labelEl ? labelEl.textContent : 'ADD TO CART';
    var sel = data.options.map(function () {
      return null;
    });
    var adding = false;

    function variantFor(s) {
      return data.variants.filter(function (v) {
        return s.every(function (val, i) {
          return val === null || v.options[i] === val;
        });
      });
    }
    function exact() {
      if (sel.some(function (s) { return s === null; })) return null;
      return variantFor(sel)[0] || null;
    }
    function render() {
      inputs.forEach(function (input) {
        var i = parseInt(input.getAttribute('data-option-index'), 10);
        var other = sel.slice();
        other[i] = input.value;
        var ok = variantFor(other).some(function (v) { return v.available; });
        input.checked = sel[i] === input.value;
        input.disabled = !ok && !input.checked;
        var label = modal.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !ok);
      });
      DM.$$('[data-option-index].dm-opt', modal).forEach(function (fs) {
        var i = parseInt(fs.getAttribute('data-option-index'), 10);
        var v = fs.querySelector('[data-dm-sp-value]');
        if (v) v.textContent = sel[i] !== null ? sel[i] : str.select || 'Select';
      });
      var variant = exact();
      var missing = sel.indexOf(null);
      if (priceEl) {
        var list = variantFor(sel);
        var prices = list.map(function (v) { return v.price; });
        if (prices.length) {
          var min = Math.min.apply(null, prices);
          var max = Math.max.apply(null, prices);
          priceEl.textContent = min === max ? DM.money(min) : DM.fmt(str.from || 'From {price}', { price: DM.money(min) });
        }
        if (compareEl) {
          var valid =
            list.length > 0 &&
            list.every(function (v) {
              return v.compare && v.compare > v.price;
            });
          compareEl.hidden = !valid;
          if (valid) {
            var low = list.slice().sort(function (a, b) {
              return a.price - b.price;
            })[0];
            compareEl.textContent = DM.money(low.compare);
          }
        }
      }
      if (!labelEl || !addBtn) return;
      if (adding) {
        labelEl.textContent = str.adding || 'ADDING…';
        addBtn.disabled = true;
      } else if (missing !== -1) {
        labelEl.textContent = DM.fmt(str.selectOption || 'Choose my __OPTION__', { option: data.options[missing].name.toLowerCase() });
        addBtn.disabled = false;
      } else if (!variant || !variant.available) {
        labelEl.textContent = str.soldOut || 'SOLD OUT';
        addBtn.disabled = true;
      } else {
        labelEl.textContent = restLabel + ' · ' + DM.money(variant.price);
        addBtn.disabled = false;
      }
    }

    // colors start on the first value, other options (size) start empty so the shopper has to choose
    data.options.forEach(function (o, i) {
      if (/^colou?r$/i.test(o.name)) sel[i] = o.values[0];
    });
    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        sel[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
        if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
        render();
      });
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (adding) return;
      var missing = sel.indexOf(null);
      if (missing !== -1) {
        if (errEl) {
          errEl.textContent = DM.fmt(str.chooseOptionError || 'Please choose a __OPTION__.', { option: data.options[missing].name.toLowerCase() });
          errEl.hidden = false;
        }
        var fs = modal.querySelector('.dm-opt[data-option-index="' + missing + '"] .dm-opt__input:not([disabled])');
        if (fs) fs.focus();
        return;
      }
      var variant = exact();
      if (!variant || !variant.available || !window.DMCart) return;
      adding = true;
      render();
      window.DMCart.add([{ id: variant.id, quantity: 1 }], { source: 'sticky-bar' })
        .then(function () {
          adding = false;
          render();
        })
        .catch(function (err) {
          adding = false;
          render();
          if (err && err.message === 'busy') return;
          if (errEl) {
            errEl.textContent = str.addError || 'Something went wrong. Please try again.';
            errEl.hidden = false;
          }
        });
    });
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
